import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MessageDisplayDialogComponent } from '../message-display-dialog.component';
import { MessageActions } from './message.actions';

@Injectable()
export class MessageEffects {
    constructor(
        private actions$: Actions,
        private modalService: BsModalService) {
    }

    openMessagePreviewDialogJS$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(MessageActions.openMessagePreviewDialogJS),
                    map(({messageUuid, mediaType, isTrackingcode, messageType}) => {
                        this.modalService
                            .show(MessageDisplayDialogComponent,
                                {
                                    initialState: {
                                        messageUuid,
                                        mediaType,
                                        isTrackingcode,
                                        messageType
                                    },
                                    backdrop: 'static',
                                    class: 'modal-lg-preview',
                                    keyboard: false // disable esc key

                                });
                    })),
        { dispatch: false }
    );
}
